// extracted by mini-css-extract-plugin
export default {"middle":"styles_middle__-fmtQ","success":"styles_success__GtsSI","title":"styles_title__UOH5r","desc":"styles_desc__4JTEw","button":"styles_button__AYShF"};